import React, { createContext, useContext } from 'react';

export const DashboardContext = createContext(null);

export function useDashboard() {
  const ctx = useContext(DashboardContext);
  if (!ctx) throw new Error('useDashboard must be used within DashboardContext.Provider');
  return ctx;
}
